import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { withDefaults } from 'vue';

interface IProps {
  title: string;
  classes?: string[];
  noMargin?: boolean;
  fontSize?: string;
  fontWeight?: string;
  lineHeight?: string;
  noDivider?: boolean;
  useGradient?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomTitle',
  props: {
    title: {},
    classes: {},
    noMargin: { type: Boolean },
    fontSize: {},
    fontWeight: {},
    lineHeight: {},
    noDivider: { type: Boolean },
    useGradient: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", {
      style: _normalizeStyle({ marginBottom: _ctx.noMargin ? 0 : '16px', fontSize: _ctx.fontSize ? _ctx.fontSize : '', lineHeight: _ctx.lineHeight ? _ctx.lineHeight : '', fontWeight: _ctx.fontWeight ? _ctx.fontWeight : ''  }),
      class: _normalizeClass([_ctx.classes, _ctx.useGradient ? 'label-text' : ''])
    }, _toDisplayString(props.title), 7),
    (!_ctx.noDivider)
      ? (_openBlock(), _createBlock(_component_v_divider, {
          key: 0,
          class: "mt-2 mb-4 color-divider"
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})